var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTextExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A4A9C8",
    d: "M24 21h-6c-.265 0-.52.107-.707.294l-.293.293V11.415L18.414 10H24v11zm-10 0H8V10h5.586L15 11.416v10.172l-.293-.293C14.52 21.106 14.265 21 14 21zM25 8h-7c-.265 0-.52.107-.707.293L16 9.586l-1.293-1.293c-.187-.186-.442-.292-.707-.292H7c-.552 0-1 .447-1 1v13c0 .551.448 1 1 1h6.586l1.707 1.706c.195.195.451.293.707.293.256 0 .512-.098.707-.293L18.414 23H25c.552 0 1-.448 1-1V9c0-.552-.448-1-1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTextExperiment);
export default __webpack_public_path__ + "static/media/ico-text-experiment.f2e3c095281f74e8706ee85c51fb94cf.svg";
export { ForwardRef as ReactComponent };